import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { borderRadius } from "../../../design-system/tokens/borders";
import { shadows } from "../../../design-system/tokens/shadows";
import { typographyMixin } from "../../../design-system/tokens/typography";

/** Figma panel column width (node 6515:241171 and the 7 group frames below it). */
export const PanelRoot = styled.div`
  display: flex;
  flex-direction: column;
  width: 16.5rem; // 264px
  height: 100%;
  background-color: ${rawColors.structural.white};
  border-radius: ${borderRadius.xl};
  /** Separates the docked column from the page wash — same "docked control"
   *  shadow as ChatToggleButton. */
  box-shadow: ${shadows.component.card.control_panel};
  overflow: hidden;

  /* Figma's own frames size children via border-box auto-layout; without
   * this every 100%-width row here (header, search box, group, toggle row)
   * grows past this fixed 264px column by its own padding and forces the
   * horizontal scrollbar Figma never shows. Scoped to the panel only. */
  box-sizing: border-box;
  * {
    box-sizing: border-box;
  }
`;

export const GroupList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const EmptyState = styled.div`
  padding: 0.75rem;
  ${typographyMixin("caption", 4)}
  color: ${rawColors.text.lowEmphasis};
`;
